import { ScatterplotLayer } from "@deck.gl/layers";
import mapData from "lib/stores/mapData";
import { easeOutBack } from "lib/helpers/math";
import apiData from "lib/stores/apiData";

const setScatterplotLayer = productsCountry => {
  const getData = () => {
    try {
      if (productsCountry && mapData.selectedProduct) {
        const returnData = [
          {
            coordinates: [apiData.countries[productsCountry].centroid.cx, apiData.countries[productsCountry].centroid.cy]
          }
        ];
        return returnData;
      }
      return {
        type: "FeatureCollection",
        features: []
      };
    } catch (error) {
      return {
        type: "FeatureCollection",
        features: []
      };
    }
  };

  const getDestinationSpot = () => {};

  return new ScatterplotLayer({
    id: "circles",
    data: getData(),
    opacity: 1,
    stroked: false,
    filled: true,
    radiusScale: productsCountry ? 75 : 0,
    radiusMinPixels: 10,
    // radiusMaxPixels: 20,
    getPosition: d => {
      return [d.coordinates[0], d.coordinates[1]];
    },
    getPolygonOffset: ({ layerIndex }) => [-2000, 10],
    getRadius: d => (productsCountry ? 1000 : 0),
    getFillColor: d => [25, 25, 25, 255],
    updateTrigger: {
      getRadius: productsCountry,
      getPosition: productsCountry,
      getPolygonOffset: productsCountry,
      getFillColor: productsCountry
    },
    transitions: {
      getRadius: {
        duration: 500,
        easing: easeOutBack
      },
      radiusScale: {
        duration: 500,
        easing: easeOutBack
      }
    }
  });
};

export { setScatterplotLayer };
